export default {
  id: null,
  nome: null,
  inative: null
}



// WEBPACK FOOTER //
// ./src/shared/models/configurations/assuntomodel.js